/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysGet } from "../../funcs/apiKeysGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1ApiKeysKeyIdRequest$inboundSchema,
};

export const tool$apiKeysGet: ToolDefinition<typeof args> = {
  name: "api-keys_get",
  description: `Get API key details

Retrieves details of a specific API key`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
